import React, { useState } from 'react';
import { 
  Button, Dialog, DialogActions, DialogContent, DialogTitle 
} from '@mui/material';
import { createServer } from '../api';
import { useNavigate } from 'react-router-dom';
import ServerForm from './ServerForm';
import { DEFAULT_SERVER_SETTINGS } from '../constants';

export default function CreateServerDialog() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    server_settings: { 
      ...DEFAULT_SERVER_SETTINGS,
      ONLINE_MODE: 'false' // Auto-disable online mode for new servers
    },
    docker_settings: {
      ports: { '25565/tcp': 25565 }
    }
  });

  const handleChange = (section, field, value) => {
    if (section === 'root') {
      setFormData({ ...formData, [field]: value });
    } else {
      setFormData({
        ...formData,
        [section]: { ...formData[section], [field]: value }
      });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // Filter out default values before sending to backend
      const cleanSettings = {};
      
      Object.entries(formData.server_settings).forEach(([key, value]) => {
        if (value !== DEFAULT_SERVER_SETTINGS[key] && value !== "" && value !== null) {
          cleanSettings[key] = value;
        }
      });

      const cleanData = {
          ...formData,
          server_settings: cleanSettings
      };

      await createServer(cleanData);
      setOpen(false);
      navigate(`/server/${formData.name}`);
    } catch (error) {
      alert('Failed to create server: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Create New Server
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Create Minecraft Server</DialogTitle>
        <DialogContent>
          <ServerForm data={formData} onChange={handleChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={loading}>
            {loading ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}